import { Image } from "@heroui/image";
import React from "react";

import { TextStrip3 } from "@/public/assets";
import { FindTalent, ApplyForJob, RecruitingImageSlider } from "@/components";

const RecruitmentPartner = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 py-10 sm:py-12">
      <div>
        <div
          className="mb-4 text-black dark:text-foreground-950 text-[24px] sm:text-[28px] md:text-[32px] text-center mx-auto font-medium leading-8 sm:leading-9 md:leading-10 tracking-[-0.16px] max-w-xl"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          We not just a <span className="line-through">dashboard</span>, <br />
          we are your{" "}
          <span className="italic text-primary-600 dark:text-primary relative">
            recruitment partner
            <div className="absolute -bottom-1 inset-x-0">
              <Image
                disableSkeleton
                alt="strip 2 image"
                className="animate__animated animate__flipInX w-full"
                src={TextStrip3.src}
              />
            </div>
          </span>
        </div>

        <div
          className="text-foreground-700 dark:text-foreground-600 font-normal text-sm sm:text-base leading-5 sm:leading-6 tracking-[-0.176px] mb-6 text-center max-w-2xl px-2 sm:px-6 md:px-10 mx-auto"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          You don’t need another dashboard to scroll through, you need the right
          people. At Cotton Recruiting, we understand your business and connect
          you with talent that’s ready to contribute, not just available.
        </div>

        <div
          className="flex flex-col sm:flex-row items-center mb-6 gap-3 justify-center mx-auto max-w-md"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <FindTalent />
          <ApplyForJob />
        </div>

        <div
          className="rounded-[24px] sm:rounded-[28px] md:rounded-[32px] h-[30vh] sm:h-[38vh] md:h-[45vh] flex items-center justify-center overflow-hidden"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          <RecruitingImageSlider className="rounded-[24px] sm:rounded-[28px] md:rounded-[32px]" />
        </div>
      </div>
    </section>
  );
};

export default RecruitmentPartner;
